import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _inRange from "lodash/inRange";
import _find from "lodash/find";
import _get from "lodash/get";

var _LOAN_PROGRAM_NAME;

import "core-js/modules/es6.number.constructor.js";
import { LOAN_PURPOSE_PURCHASE, LOAN_PROGRAM_FIXED_30, LOAN_PROGRAM_FIXED_20, LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_FIXED_10, LOAN_PROGRAM_ARM_7, LOAN_PROGRAM_ARM_5, LOAN_PROGRAM_ARM_3, LOAN_PROGRAM_ARM_10 } from '../config/data/constants';
import { creditScoreRange } from '../config/data/ranges';
/**
 * Unsure. Probably unused.
 * @todo unused?
 * @private
 * @deprecated
 */

export var getLowerBoundFromRangeById = function getLowerBoundFromRangeById(ranges, id) {
  return _get(_find(ranges, {
    id: Number(id)
  }), 'range[0]');
};
/**
 * Unsure. Probably unused.
 * @todo unused?
 * @private
 * @deprecated
 */

export var getFromRangeByValue = function getFromRangeByValue(ranges, value) {
  return _find(ranges, function (_ref) {
    var _ref$range = _slicedToArray(_ref.range, 2),
        min = _ref$range[0],
        max = _ref$range[1];

    return _inRange(value, min, max + 1);
  });
};
/**
 * Lookup object for human friendly loan program names. Keys are LOAN_PROGRAM constants
 * @see getLoanProgramName
 * @deprecated
 */

export var LOAN_PROGRAM_NAME = (_LOAN_PROGRAM_NAME = {}, _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_30, '30-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_20, '20-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_15, '15-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_FIXED_10, '10-year fixed'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_7, '7-year ARM'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_5, '5-year ARM'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_3, '3-year ARM'), _defineProperty(_LOAN_PROGRAM_NAME, LOAN_PROGRAM_ARM_10, '10-year ARM'), _LOAN_PROGRAM_NAME);
/**
 * Gets a human friendly description of a loan program
 * @example
 * import { LOAN_PROGRAM_FIXED_15, LOAN_PROGRAM_ARM_5 } from '@nerdwallet/home-app-lib/constants';
 * import { getLoanProgramName } from '@nerdwallet/home-app-lib/helpers';
 *
 * getLoanProgramName(LOAN_PROGRAM_FIXED_15); // 15-year fixed
 * getLoanProgramName(LOAN_PROGRAM_ARM_5); // 5 ARM
 * @function
 * @param  {external:home-constants.LOAN_PROGRAM} loanProgram
 * @return {String}
 */

export var getLoanProgramName = function getLoanProgramName(loanProgram) {
  return _get(LOAN_PROGRAM_NAME, loanProgram, loanProgram);
};
/**
 * Is the purpose of this loan purchasing a home
 * @example
 * import { LOAN_PURPOSE_PURCHASE, LOAN_PURPOSE_REFINANCE } from '@nerdwallet/home-app-lib/constants';
 * import { isPurchase } from '@nerdwallet/home-app-lib/helpers';
 *
 * isPurchase({ loanPurpose: LOAN_PURPOSE_PURCHASE }); // true
 * isPurchase({ loanPurpose: LOAN_PURPOSE_REFINANCE }); // false
 * @function
 * @param  {Object}  data
 * @param  {external:home-constants.LOAN_PURPOSE}  data.loanPurpose  The purpose of the loan, LOAN_PURPOSE_PURCHASE or LOAN_PURPOSE_REFINANCE
 * @return {Boolean}      true if Purchase, false if Refinance
 */

export var isPurchase = function isPurchase(data) {
  return _get(data, 'loanPurpose') === LOAN_PURPOSE_PURCHASE;
};
/**
 * Get the loan amount.  This should only be used for approximating the loan amount, and never
 * for an actual mortgage offer, as offers may roll fees into the loan amount
 * @todo Potentially incorrect.  Where / why is this used?
 * @example // for Refi
 * import { LOAN_PURPOSE_REFINANCE } from '@nerdwallet/home-app-lib/constants';
 * import { getLoanAmount } from '@nerdwallet/home-app-lib/helpers';
 *
 * getLoanAmount({
 *   loanPurpose: LOAN_PURPOSE_REFINANCE,
 *   mortgageBalance: 50,
 *   cashout: 10,
 * }); // 60
 *
 * getLoanAmount({
 *   loanPurpose: LOAN_PURPOSE_REFINANCE,
 *   mortgageBalance: 50,
 * }); // 50
 *
 * @example // for Purchase
 * import { LOAN_PURPOSE_PURCHASE } from '@nerdwallet/home-app-lib/constants';
 * import { getLoanAmount } from '@nerdwallet/home-app-lib/helpers';
 *
 * getLoanAmount({
 *   loanPurpose: LOAN_PURPOSE_PURCHASE,
 *   purchasePrice: 50,
 *   downPayment: 10,
 * }); // 40
 * @function
 * @param  {Object} data
 * @param  {external:home-constants.LOAN_PURPOSE} data.loanPurpose  The purpose of the loan, LOAN_PURPOSE_PURCHASE or LOAN_PURPOSE_REFINANCE
 * @param  {Number} [data.purchasePrice]  Required if loanProgram=purchase. The purchase price of the property.
 * @param  {Number} [data.downPayment]  Required if loanProgram=purchase. The down payment for the loan
 * @param  {Number} [data.mortgageBalance]  Required if loanProgram=refinance. The user's current mortgage balance
 * @param  {Number} [data.cashout=0]  Required if loanProgram=refinance. The amount of cashout the user requested
 * @return {Number}      The amount of the loan
 */

export var getLoanAmount = function getLoanAmount(data) {
  if (isPurchase(data)) {
    return _get(data, 'purchasePrice') - _get(data, 'downPayment');
  }

  return _get(data, 'mortgageBalance') + _get(data, 'cashout', 0);
};
/**
 * Print the credit score range for when you need to display the user's credit score but you only have a range value.
 * @example
 * import { getCreditScoreRange } from '@nerdwallet/home-app-lib/helpers';
 *
 * getCreditScoreRange(301); // 300 - 579
 * getCreditScoreRange(640); // 640 - 659
 * getCreditScoreRange(760); // 760+
 * getCreditScoreRange('test'); // ''
 * @function
 * @param  {Number}  creditScore
 * @return {String}  string representation of credit score range
 */

export var getCreditScoreRange = function getCreditScoreRange(creditScore) {
  for (var i = 0; i < creditScoreRange.length; i += 1) {
    var range = creditScoreRange[i];

    if (!range[1] && creditScore >= range[0]) {
      return "".concat(range[0], "+");
    }

    if (range[1] && creditScore <= range[1] && creditScore >= range[0]) {
      return "".concat(range[0], " - ").concat(range[1]);
    }
  }

  return '';
};